import { Grid } from '@mui/material';
import { HashtagMentionTypeEnum } from 'redux-store/api/activity-feed/hashtags.types';
import { useAppDispatch } from 'redux-store/hooks/useAppDispatch';
import { setHashtagMetadata } from 'redux-store/slices/hashtag-slice';
import { isContentEmpty } from 'utils/helpers';
import { createHashtagPayload } from 'utils/mappers';

interface IRichTextContent {
  sx: any;
  content: string;
  projectId: number;
  onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

export const RichTextContent = ({ sx, content, projectId, onClick }: IRichTextContent) => {
  const dispatch = useAppDispatch();

  if (!content || isContentEmpty(content)) return null;

  const html = content.replace(/(?<!href=["'])https?:\/\/[^\s<]+/g, (url) => {
    return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
  });

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    const target = e.target as HTMLElement;

    const hashtagEl = target.closest('[data-mention-type="hashtag"]') as HTMLElement | null;

    if (hashtagEl) {
      const hasAccess = hashtagEl.getAttribute('data-has-access') !== 'false';
      if (!hasAccess) {
        e.stopPropagation();
        return;
      }

      const hashtagType = hashtagEl.getAttribute('data-hashtag-type') as HashtagMentionTypeEnum;
      const hashtagId = hashtagEl.getAttribute('data-hashtag-id');
      const mimeType = hashtagEl.getAttribute('data-mimeType');

      const payload = createHashtagPayload({
        type: hashtagType,
        id: Number(hashtagId),
        mimeType,
        projectId,
      });

      dispatch(setHashtagMetadata(payload));

      e.stopPropagation();
      return;
    }

    if (onClick) onClick(e);
  };

  return (
    <Grid
      sx={{
        ...sx,
        '& [data-has-access="false"]': { position: 'relative', opacity: '0.6 !important' },
        '& [data-has-access="false"]:hover': { opacity: '1 !important' },
        '& [data-has-access="false"]:hover::after': {
          content: '"No permission to view item"',
          position: 'absolute',
          top: '100%',
          left: '50%',
          transform: 'translateX(-50%)',
          backgroundColor: '#ffffff',
          color: '#424550',
          fontSize: '12px',
          fontFamily: 'Inter, sans-serif',
          fontWeight: 500,
          padding: '6px 10px',
          borderRadius: '6px',
          border: '1px solid #E0E2EA',
          boxShadow: '0px 4px 12px rgba(0,0,0,0.08)',
          whiteSpace: 'nowrap',
          zIndex: 9999,
          pointerEvents: 'none',
          marginTop: '4px',
        },
      }}
      onClick={handleClick}
    >
      <div dangerouslySetInnerHTML={{ __html: html }} />
    </Grid>
  );
};
